import { render, staticRenderFns } from "./SettingModalContent.vue?vue&type=template&id=72cb8900&scoped=true"
import script from "./SettingModalContent.vue?vue&type=script&lang=js"
export * from "./SettingModalContent.vue?vue&type=script&lang=js"
import style0 from "./SettingModalContent.vue?vue&type=style&index=0&id=72cb8900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb8900",
  null
  
)

export default component.exports